import React, { useEffect, useState } from "react";
import "./SectionIndex.scss";

type Props = {
    selectedIndexFn: (selectedIndex: string) => void;
    selectedSection?: string;
};

export const SectionIndex: React.FC<Props> = (props) => {
    const [selectedSection, setSelectedSection] = useState("");

    useEffect(() => {
        props.selectedIndexFn(selectedSection);
    }, []);

    useEffect(() => {
        if (props.selectedSection !== selectedSection) {
            props.selectedIndexFn(selectedSection);
        }
    }, [selectedSection]);

    const _setSelectedSection = (section: string) => {
        setSelectedSection(section);
    };

    const sectionsArr = [
        { label: "A" },
        { label: "B" },
        { label: "C" },
        { label: "D" },
        { label: "E" },
        { label: "F" },
        { label: "G" },
        { label: "H" },
        { label: "I" },
        { label: "J" },
        { label: "K" },
        { label: "L" },
        { label: "M" },
        { label: "N" },
        { label: "O" },
        { label: "P" },
        { label: "Q" },
        { label: "R" },
        { label: "S" },
        { label: "T" },
        { label: "U" },
        { label: "V" },
        { label: "W" },
        { label: "X" },
        { label: "Y" },
        { label: "Z" },
        { label: "0" },
        { label: "1" },
        { label: "2" },
        { label: "3" },
        { label: "4" },
        { label: "5" },
        { label: "6" },
        { label: "7" },
        { label: "8" },
        { label: "9" },
    ];

    const sections = sectionsArr.map((section, index) => {
        const isSelectedClass = selectedSection === section.label ? "isSelected" : "";
        return (
            <div key={index} className={"d-inline-flex" + isSelectedClass}>
                <label
                    htmlFor={section.label}
                    onClick={() => {
                        _setSelectedSection(section.label);
                    }}>
                    {section.label}
                </label>
            </div>
        );
    });

    return <div className="SectionIndex d-flex flex-column">{sections}</div>;
};
